import { BrowserRouter, Routes, Route } from 'react-router-dom'
import Home from './pages/Home';
import Admin from './pages/admin/Admin';
import Test from './tests/unit_test';
import ImvSearchPage from './pages/PageImvSearch';
import { QueryClient, QueryClientProvider } from 'react-query';

// TODO: Criar checklist de componentes -> POR PAGINA <-

export default function App() {
  const queryClient = new QueryClient()

  return (<>

    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/admin" element={<Admin session_token={'1234'} />} />
          <Route path='/pesquisa' element={<ImvSearchPage />} />
        </Routes>
      </BrowserRouter>
    </QueryClientProvider>
  </>)
}